import './cursor.scss'

class Cursor {

  constructor(width) {
    this.target = { x: 0.5, y: 0.5 }
    this.cursor = { x: 0.5, y: 0.5 }
    this.speed = 0.1
    this.raf = null
    this.cursorWidth = width || 16
    this.cursorElement = document.querySelector('.cursor')
    this.init()
  }
  lerp = (a, b, n) => (1 - n) * a + n * b

  onMouseMove = (e) => {
    this.target.x = e.clientX / window.innerWidth
    this.target.y = e.clientY / window.innerHeight
    if (!this.raf) this.raf = requestAnimationFrame(this.render)
  }

  render = () => {
    this.cursor.x = this.lerp(this.cursor.x, this.target.x, this.speed)
    this.cursor.y = this.lerp(this.cursor.y, this.target.y, this.speed)
    const tx = window.innerWidth * this.cursor.x - this.cursorElement.offsetWidth / 2
    const ty = window.innerHeight * this.cursor.y - this.cursorElement.offsetWidth / 2
    this.cursorElement.style.transform = `translate3d(${tx}px, ${ty}px, 0)`
    const delta = Math.sqrt(
      Math.pow(this.target.x - this.cursor.x, 2) + Math.pow(this.target.y - this.cursor.y, 2),
    )
    if (delta < 0.001 && this.raf) {
      cancelAnimationFrame(this.raf)
      this.raf = null
      return
    }
    this.raf = requestAnimationFrame(this.render)
  }
  
  addElementEvents = (elements) => {
    elements.forEach(items => {
      items.forEach(item => item.addEventListener('mouseenter', () => this.cursorElement.classList.add('cursor--hover')))
    })
    elements.forEach(items => {
      items.forEach(item => item.addEventListener('mouseleave', () => this.cursorElement.classList.remove('cursor--hover')))
    })
  }
  
  initElements = () => {
    const links = document.querySelectorAll('a')
    const buttons = document.querySelectorAll('button')
    this.addElementEvents([links, buttons])
  }

  init = () => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      return
    }
    this.cursorElement.style.opacity = '0.8'
    this.cursorElement.style.width = `${this.cursorWidth}px`
    this.cursorElement.style.height = `${this.cursorWidth}px`
    window.addEventListener('mousemove', this.onMouseMove)
    this.raf = requestAnimationFrame(this.render)
    this.initElements()
  }
}

new Cursor()
